module.exports = __webpack_public_path__ + "static/media/iscanvas.5cb1f160.png";